/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
import { GetCompanyFromPortalAccountManagerDtoFromJSON, GetCompanyFromPortalAccountManagerDtoToJSON, } from './GetCompanyFromPortalAccountManagerDto.js';
import { NullableRangeDtoFromJSON, NullableRangeDtoToJSON, } from './NullableRangeDto.js';
import { DefaultMessageDtoFromJSON, DefaultMessageDtoToJSON, } from './DefaultMessageDto.js';
import { ImageDtoFromJSON, ImageDtoToJSON, } from './ImageDto.js';
import { LocationDtoFromJSON, LocationDtoToJSON, } from './LocationDto.js';
/**
 * Check if a given object implements the GetCompanyFromPortalResult interface.
 */
export function instanceOfGetCompanyFromPortalResult(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('location' in value) || value['location'] === undefined)
        return false;
    if (!('aboutUs' in value) || value['aboutUs'] === undefined)
        return false;
    if (!('culture' in value) || value['culture'] === undefined)
        return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined)
        return false;
    if (!('employeeStory' in value) || value['employeeStory'] === undefined)
        return false;
    if (!('employeeName' in value) || value['employeeName'] === undefined)
        return false;
    if (!('employeeFunction' in value) || value['employeeFunction'] === undefined)
        return false;
    if (!('generalImages' in value) || value['generalImages'] === undefined)
        return false;
    if (!('videoThumbnailUrl' in value) || value['videoThumbnailUrl'] === undefined)
        return false;
    if (!('videoUrl' in value) || value['videoUrl'] === undefined)
        return false;
    if (!('defaultMessages' in value) || value['defaultMessages'] === undefined)
        return false;
    if (!('relatedCompanies' in value) || value['relatedCompanies'] === undefined)
        return false;
    return true;
}
export function GetCompanyFromPortalResultFromJSON(json) {
    return GetCompanyFromPortalResultFromJSONTyped(json, false);
}
export function GetCompanyFromPortalResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'location': LocationDtoFromJSON(json['location']),
        'aboutUs': json['aboutUs'],
        'culture': json['culture'],
        'employeeCount': NullableRangeDtoFromJSON(json['employeeCount']),
        'employeeStory': json['employeeStory'],
        'employeeName': json['employeeName'],
        'employeeFunction': json['employeeFunction'],
        'logo': json['logo'] == null ? undefined : ImageDtoFromJSON(json['logo']),
        'cover': json['cover'] == null ? undefined : ImageDtoFromJSON(json['cover']),
        'employeeProfilePicture': json['employeeProfilePicture'] == null ? undefined : ImageDtoFromJSON(json['employeeProfilePicture']),
        'generalImages': (json['generalImages'].map(ImageDtoFromJSON)),
        'videoThumbnailUrl': json['videoThumbnailUrl'],
        'videoUrl': json['videoUrl'],
        'defaultMessages': (json['defaultMessages'].map(DefaultMessageDtoFromJSON)),
        'accountManager': json['accountManager'] == null ? undefined : GetCompanyFromPortalAccountManagerDtoFromJSON(json['accountManager']),
        'relatedCompanies': (json['relatedCompanies'].map(ItemFromJSON)),
    };
}
export function GetCompanyFromPortalResultToJSON(json) {
    return GetCompanyFromPortalResultToJSONTyped(json, false);
}
export function GetCompanyFromPortalResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'location': LocationDtoToJSON(value['location']),
        'aboutUs': value['aboutUs'],
        'culture': value['culture'],
        'employeeCount': NullableRangeDtoToJSON(value['employeeCount']),
        'employeeStory': value['employeeStory'],
        'employeeName': value['employeeName'],
        'employeeFunction': value['employeeFunction'],
        'logo': ImageDtoToJSON(value['logo']),
        'cover': ImageDtoToJSON(value['cover']),
        'employeeProfilePicture': ImageDtoToJSON(value['employeeProfilePicture']),
        'generalImages': (value['generalImages'].map(ImageDtoToJSON)),
        'videoThumbnailUrl': value['videoThumbnailUrl'],
        'videoUrl': value['videoUrl'],
        'defaultMessages': (value['defaultMessages'].map(DefaultMessageDtoToJSON)),
        'accountManager': GetCompanyFromPortalAccountManagerDtoToJSON(value['accountManager']),
        'relatedCompanies': (value['relatedCompanies'].map(ItemToJSON)),
    };
}
